import { Autocomplete, Checkbox, Grid, InputAdornment, LinearProgress, TextField } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { useQuery } from "react-query";
import axiosClient from "../../../../../../lib/axios";
import { IDataLojas } from "../../../../../../types/api/geral/pesquisar-lojas";
import { IDataSetores } from "../../../../../../types/api/estoque/pesquisar-setores";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import truncarString from "../../../../../../helpers/truncarString";
import DateComIntervalo from "../../../../../../components/DateComIntervalo";
import { TFiltrosState } from "..";
import { TStateObjFiltros, filtrarLabelTodosFiltros } from "../../../../../../helpers/filtrarLabelTodosFiltros";
import { IDataDepartamentosEstoque } from "../../../../../../types/api/estoque/pesquisar-departamentos-estoque";

export default function FiltrosCabecalho({
    filtros,
    onChangeFiltros
}: FiltrosCabecalhoProps) {

    //queries
    const { data: lojaResult, isLoading: isLoadingLoja } = useQuery({
        queryKey: ["pesquisar-lojas"],
        queryFn: () => axiosClient.get("/pesquisar-lojas", {
            params: {
                limit: 200
            }
        })
    });
    const { dataLojas }: ILojas = {
        dataLojas: lojaResult?.data.data || []
    }

    const { data: departamentoResult, isLoading: isLoadingDepartamento } = useQuery({
        queryKey: ["pesquisar-departamentos-estoque"],
        queryFn: () => axiosClient.get("estoque/pesquisar-departamentos", {
            params: {
                limit: 300
            }
        })
    });
    const { dataDepartamentos }: IDepartamentos = {
        dataDepartamentos: departamentoResult?.data.data || []
    }

    const { data: setoresResult, isLoading: isLoadingSetores } = useQuery({
        queryKey: ["pesquisar-setores-estoque"],
        queryFn: () => axiosClient.get("estoque/pesquisar-setores", {
            params: {
                limit: 400
            }
        })
    });
    const { dataSetores }: ISetores = {
        dataSetores: setoresResult?.data.data || []
    }
    //

    //funcoes manipuladoras
    const handleChange = (value: TStateObjFiltros[], type: "loja" | "departamento" | "setor") => {
        const valorFinal = value.length > 0 ? filtrarLabelTodosFiltros(value) : [{ id: null, nome: type === "loja" ? "Todas" : "Todos" }]

        onChangeFiltros(type, valorFinal)
    }
    //

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    return (
        <Grid container spacing={1}>
            <Grid size={{ xs: 6, md: 2.4 }}>
                <TextField
                    label="Pesquisar"
                    variant="outlined"
                    fullWidth
                    slotProps={{
                        input: {
                            endAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            )
                        }
                    }}
                    onChange={(e) => onChangeFiltros("pesquisar", e.target.value)}
                />
            </Grid>

            <Grid size={{ xs: 6, md: 2.4 }}>
                <DateComIntervalo
                    data={{
                        inicial: filtros.dataInicial,
                        final: filtros.dataFinal
                    }}
                    onChangeData={(data) => {
                        onChangeFiltros("dataInicial", data.inicial)
                        onChangeFiltros("dataFinal", data.final)
                    }}
                />
            </Grid>

            <Grid size={{ xs: 6, md: 2.4 }}>
                <Autocomplete
                    multiple
                    value={filtros.loja}
                    id="checkboxes-tags-demo"
                    disableCloseOnSelect
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    disabled={isLoadingLoja}
                    getOptionLabel={(option) => option.nome}
                    onChange={(_, v) => handleChange(v, "loja")}
                    options={[{ id: null, nome: "Todas" }, ...dataLojas.map(item => ({ id: item.id, nome: item.nome }))]}
                    renderTags={(value) => truncarString(value.map(item => item.nome).join(', '), 9)}
                    renderOption={(props, option, { selected }) => {
                        return (
                            <li {...props}>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.nome}
                            </li>
                        )
                    }}
                    renderInput={(params) => {
                        return (
                            <TextField {...params} label="Loja" />
                        )
                    }}
                />
                {
                    isLoadingLoja &&
                    <LinearProgress sx={{ mt: 0.2 }} />
                }
            </Grid>

            <Grid size={{ xs: 6, md: 2.4 }}>
                <Autocomplete
                    multiple
                    value={filtros.departamento}
                    id="checkboxes-tags-demo"
                    disableCloseOnSelect
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    disabled={isLoadingDepartamento}
                    getOptionLabel={(option) => option.nome}
                    onChange={(_, v) => handleChange(v, "departamento")}
                    options={[{ id: null, nome: "Todos" }, ...dataDepartamentos]}
                    renderTags={(value) => truncarString(value.map(item => item.nome).join(', '), 9)}
                    renderOption={(props, option, { selected }) => {
                        return (
                            <li {...props}>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.nome}
                            </li>
                        )
                    }}
                    renderInput={(params) => {
                        return (
                            <TextField {...params} label="Departamento" />
                        )
                    }}
                />
                {
                    isLoadingDepartamento &&
                    <LinearProgress sx={{ mt: 0.2 }} />
                }
            </Grid>

            <Grid size={{ xs: 6, md: 2.4 }}>
                <Autocomplete
                    multiple
                    value={filtros.setor}
                    id="checkboxes-tags-demo"
                    disableCloseOnSelect
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    disabled={isLoadingSetores}
                    getOptionLabel={(option) => option.nome}
                    onChange={(_, v) => handleChange(v, "setor")}
                    options={[{ id: null, nome: "Todos" }, ...dataSetores]}
                    renderTags={(value) => truncarString(value.map(item => item.nome).join(', '), 9)}
                    renderOption={(props, option, { selected }) => {
                        return (
                            <li {...props}>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.nome}
                            </li>
                        )
                    }}
                    renderInput={(params) => {
                        return (
                            <TextField {...params} label="Setor" />
                        )
                    }}
                />
                {
                    isLoadingSetores &&
                    <LinearProgress sx={{ mt: 0.2 }} />
                }
            </Grid>
        </Grid>
    )
}

interface FiltrosCabecalhoProps {
    filtros: TFiltrosState
    onChangeFiltros: (prop: keyof TFiltrosState, value: any) => void
}
interface ILojas {
    dataLojas: IDataLojas[]
}

interface IDepartamentos {
    dataDepartamentos: IDataDepartamentosEstoque[]
}

interface ISetores {
    dataSetores: IDataSetores[]
}

